/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable eslint-comments/no-restricted-disable */

import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EmbeddedWhiteboardModalEntrypointEntrypointProps } from './EmbeddedWhiteboardModalEntrypoint.entrypoint.types.tsx';

type EmbeddedWhiteboardModalEntrypointComponent = EntryPointComponent<
	{},
	{},
	EmbeddedWhiteboardModalEntrypointEntrypointProps,
	{}
>;

export const embeddedWhiteboardModalEntrypoint: EntryPoint<
	EmbeddedWhiteboardModalEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<EmbeddedWhiteboardModalEntrypointComponent>(
		/* webpackChunkName: "async-embedded-confluence-whiteboard-modal" */ './EmbeddedWhiteboardModalEmbeddedWhiteboardModal.tsx',
	),
	getPreloadProps: () => ({}),
});
